<div class="social-login-buttons" [class.login-modal]="loginModal">
  <app-error-block *ngIf="unknownError()">
    {{ unknownErrorMessage() }}
  </app-error-block>
  <button
    class="social-login-button google-login-button"
    (click)="googleClient.requestAccessToken()"
  >
    <img src="/assets/icons/icon-google.svg" alt="Google Logo" />
    <span>Google</span>
  </button>
  <button
    class="social-login-button apple-login-button"
    (click)="appleSignIn()"
  >
    <img src="/assets/icons/icon-apple.svg" alt="Apple Logo" />
    <span>Apple</span>
  </button>
  <button
    class="social-login-button facebook-login-button"
    (click)="facebookSignIn()"
  >
    <img src="/assets/icons/icon-facebook.svg" alt="Facebook Logo" />
    <span>Facebook</span>
  </button>
</div>
